import Socket from 'socket.io-client';
import { URL_API } from './urlsApi';

// 1. Usar el protocolo 'wss://' en producción si URL_API apunta a Heroku.
// Esto garantiza que la conexión WebSocket se establezca sobre SSL/TLS.
const clientURL = URL_API.startsWith('https://')
    ? URL_API.replace('https://', 'wss://')
    : URL_API.startsWith('http://')
        ? URL_API.replace('http://', 'ws://')
        : URL_API;

const socket = Socket(clientURL, {
    // 2. Transports: Incluir 'polling' como fallback.
    // Aunque priorizamos 'websocket', si la red del usuario bloquea WebSockets, 
    // Socket.IO caerá de forma segura a long-polling, mitigando el error H12 
    // en la fase de handshake inicial en clientes con restricciones de red.
    transports: ['websocket', 'polling'],

    // 3. Keep-alive (Ping times): Coincidir con la configuración del servidor (25s)
    // Esto es crucial para que el cliente espere el ping del servidor a tiempo 
    // y maneje correctamente la reconexión si la conexión se rompe.
    pingInterval: 25000,
    pingTimeout: 120000,

    // 4. Configuración de reconexión (CRUCIAL en Heroku por H15)
    // Cuando Heroku corta la conexión por H15 (inactividad de 55s), 
    // el cliente debe intentar reconectar de inmediato.
    reconnection: true,
    reconnectionAttempts: Infinity, // Intentar indefinidamente
    reconnectionDelay: 1000,        // Esperar 1 segundo antes de reintentar
});

// 5. Manejo de Eventos de Conexión y Reconexión (Ejemplo)
// Esto ayuda a depurar y a gestionar el estado de la aplicación (ej. mostrar 'conectando...')

socket.on('connect', () => {
    console.log(`[Socket] Conectado. ID: ${socket.id}`);
    // Opcional: Si el token se envía en el momento de la conexión (tokenSocket)
    // Si tienes el token disponible, podrías emitirlo aquí tras la conexión o reconexión.
});

socket.on('disconnect', (reason) => {
    // Si la razón es 'ping timeout', significa que el servidor no respondió al ping del cliente 
    // o el H15 de Heroku actuó antes de que Socket.IO pudiera reaccionar.
    console.log(`[Socket] Desconectado. Razón: ${reason}`);
});

socket.on('disconnect', (reason) => {
    // ⚠️ LA CLAVE: Necesitamos saber esta razón.
    console.log(`[Socket] Desconectado. Razón: ${reason}`);
});

socket.on('connect_error', (error) => {
    console.error(`[Socket] Error de conexión: ${error.message}`);
});

socket.on('reconnect_attempt', (attempt) => {
    console.log(`[Socket] Intentando reconexión... Intento #${attempt}`);
});


export default socket;